import { render, staticRenderFns } from "./GeodesiaLab.vue?vue&type=template&id=27e747dc&scoped=true"
import script from "./GeodesiaLab.vue?vue&type=script&lang=js"
export * from "./GeodesiaLab.vue?vue&type=script&lang=js"
import style0 from "./GeodesiaLab.vue?vue&type=style&index=0&id=27e747dc&prod&scoped=true&lang=css"
import style1 from "./GeodesiaLab.vue?vue&type=style&index=1&id=27e747dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e747dc",
  null
  
)

export default component.exports